import styled from '@emotion/styled';
import {ReactComponent as NoArticlesSVG} from '../../assets/icons/ic_articles_empty_state.svg';

export const CardArticlesWrapper = styled.div`
  display: grid;
  gap: ${({theme}) => theme.gap.desktop.lg};
  grid-template-columns: repeat(auto-fill, minmax(264px, 1fr));
`;

export const IconNoArticles = styled(NoArticlesSVG)`
  width: ${({theme}) => theme.icon.size.lg};
  height: ${({theme}) => theme.icon.size.lg};
  fill: ${({theme}) => theme.color.neutral.grey_900};
`;
